export const Label = ({ label, name, className = '', children = null, isPhone = false }) => {
  return (
    <label className={className} htmlFor={name}>
      {children ? children : label} {isPhone && <span className="text-red-600">*</span>}
    </label>
  )
}
